import { Popover } from '@mui/material'
import { DialogTitle, IconButton, Typography } from '@mui/material';
import { TooltipCC } from 'components/common';
import { POPOVER } from 'constants/common';
import theme from 'theme';
import './Popover.css';
import { useTranslation } from 'react-i18next';
import { IconClose } from 'assets/icons';

const PopoverCC = ({ open, anchorEl, setAnchorEl, title, position = POPOVER.POSITION.CENTER, children }) => {
    const {t} = useTranslation()

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            sx={{ borderRadius: theme.spacing(1.5) }}
        >
            <div>
                <DialogTitle>
                    <Typography
                        sx={{ fontSize: "1.5rem", fontWeight: 700 }}
                    >
                        {title || 'Dialog title'}
                    </Typography>
                    <TooltipCC title={t('dialog.close')}>
                        <IconButton sx={{ position: 'absolute', right: 0, top: 0, p: 0.5, m: 0.5 }} aria-label="close" onClick={() => setAnchorEl(null)}>
                            <IconClose />
                        </IconButton>
                    </TooltipCC>
                </DialogTitle>
                {children}
            </div>
        </Popover>
    )
}

export default PopoverCC